/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import axios from 'axios'

const qs = require('qs')

export default {
  state: {
    timezones: [],
	},
	getters: {
    getTimezones(state) {
      return state.timezones
    }
	},
	mutations: {
    ADD_TIMEZONES(state, timezones) {
      state.timezones = timezones
    }
  },
  actions: {
    LOAD_TIMEZONES({ commit }) {
      return axios.post(`${process.env.VUE_APP_API_URL}/get_timezone_from_file`)
        .then(
          (response) => {
            commit('ADD_TIMEZONES', response.data.data.windowsZones.mapTimezones.mapZone)
        }
      )
    }
  }
}
